/**
 * @fileoverview Target periods query hook.
 * @description Wraps GET /sales/targets/periods in a TanStack query keyed by the period type, so
 * switching the type in Assign Target loads (and caches) that type's open periods.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getTargetPeriods } from '@/features/sales/services/sales-targets.service'

import type { SalesTargetPeriodType } from '@/features/sales/types/sales-target.types'

/**
 * @description Fetches the open periods of one type.
 * @param {SalesTargetPeriodType} type - The period type.
 * @returns {ReturnType<typeof useQuery>} The query (data is the periods and today's date).
 */
export function useTargetPeriods(type: SalesTargetPeriodType) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.targetPeriods(type),
    queryFn: () => getTargetPeriods(type),
  })
}
